import type { MetaFunction } from '@remix-run/node';

import { getCanonicalURL } from '~/utils/getCanonicalURL';

import { type loader } from './loader';
import templateStylesHref from './styles.css';
import pageStylesHref from './styles.page.css';

type metaData = Record<
  'title' |
  'description' |
  'image' |
  'ogTitle' |
  'ogDescription' |
  'twitterUrl' |
  'twitterDescription' |
  'twitterCard' |
  'twitterImage',
  string>;


type metaTagsMapEntry = {
  content: (m: metaData) => string;
  name?: string;
  property?: string;
};

const metaTagsMap: metaTagsMapEntry[] = [
{ name: 'description', content: (m) => m?.description },
{ property: 'og:title', content: (m) => m.ogTitle || m.title },
{
  property: 'og:description',
  content: (m) => m.ogDescription || m.description
},
{ property: 'og:image', content: (m) => m.image },
{ property: 'og:site_name', content: () => 'Oddschecker' },
{ name: 'twitter:title', content: (m) => m.title },
{
  name: 'twitter:description',
  content: (m) => m.twitterDescription || m.description
},
{ name: 'twitter:image', content: (m) => m.twitterImage || m.image },
{ name: 'twitter:url', content: (m) => m.twitterUrl },
{ name: 'twitter:card', content: (m) => m.twitterCard },
{ name: 'og:type', content: () => 'website' }];


const constructMetaTags = (meta: metaData) => (item: metaTagsMapEntry) => {
  const value = item.content(meta);
  if (value) return { ...item, content: value };
};

export const meta: MetaFunction<
  never,
  {
    [routeId: string]: typeof loader;
  }> =
({ location, matches }) => {
  const data = matches.find((match) => /offers-page/.test(match.id))?.data;

  const offersData =
  data?.offersListResponse.dehydratedState.queries[0].state.data;

  const css = [
  ...(data?.componentStyles || []),
  templateStylesHref,
  pageStylesHref];


  return [
  { title: offersData?.metaData.title },
  metaTagsMap.map(constructMetaTags(offersData?.metaData)),
  ...css.map((href, index) => ({
    key: `componentStyles-${index}`,
    tagName: 'link',
    rel: 'stylesheet',
    href
  })),
  {
    tagName: 'link',
    rel: 'canonical',
    href: getCanonicalURL(data?.url.toString(), location.pathname)
  }];

};